import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";

const SompoStyledText = styled(TextField)({
    "& label.Mui-focused": {
        color: "#BB0D2F",
    },
    "& .MuiOutlinedInput-root": {
        "&:hover fieldset": {
            borderColor: "#BB0D2F",
        },
        "&.Mui-focused fieldset": {
            borderColor: "#BB0D2F",
        },
    },
});

export default SompoStyledText;
